import { TripType } from '../interfaces';

export const CmsTripTypeMap = {
  [TripType.ONEWAY]: 'oneWay',
  [TripType.RETURN]: 'return',
  [TripType.MULTICITY]: 'multiCity',
};
